import { useCallback, useState } from 'react';
import { Env } from '../../shared';
import { useAdminApi, ApiError } from './client';
import { TriggerSnapshotResponse } from './types';

/**
 * Manual leaderboard snapshot re-run (SSA-816). Async invoke — returns 202
 * immediately. NOTE: the current scheduler recomputes ALL active markets and
 * ignores the market id; the id is still sent for forward-compatibility, so the
 * panel copy says "all markets" to set the right expectation.
 */
export function useTriggerSnapshot(env: Env) {
  const { request } = useAdminApi();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const trigger = useCallback(
    async (marketId: string): Promise<TriggerSnapshotResponse | null> => {
      setLoading(true);
      setError(null);
      try {
        return await request<TriggerSnapshotResponse>({
          env,
          path: `/admin/gamification/leaderboards/${marketId}/trigger`,
          method: 'POST',
        });
      } catch (e) {
        setError(e instanceof ApiError ? e.message : 'Snapshot trigger failed');
        return null;
      } finally {
        setLoading(false);
      }
    },
    [request, env],
  );

  return { loading, error, trigger };
}
